'use strict';

angular.module('amexReconciliationApp')
  .component('receiptFooterDetailsEdit', {
    bindings: {
      receipt: '<',
      closeEdit: '&'
    },
    templateUrl: 'scripts/views/components/receipt-footer-details-edit.html',
    controller: function (dateFormats,
                          toastr,
                          $translate,
                          UserModel,
                          ReceiptRepository) {

      var self = this;
      
      self.$onInit = function() {
        self.today = new Date();
        self.userDateFormat = dateFormats[(UserModel.currentUser().preferredDateFormat)];
        self.isDatePickerShowing = false;
        self.isUpdating = false;
        self.updateSuccess = $translate.instant('receipt.SuccessMessage');
        self.updateFailure = $translate.instant('receipt.FailureMessage');
        self.description = undefined;
        self.amount = undefined;
        self.date = undefined;

        if (self.receipt.details.length > 0) {
          self.description = _.cloneDeep(self.receipt.details[0].description);
          self.amount = _.cloneDeep(self.receipt.details[0].amount);
          self.date = _.cloneDeep(self.receipt.details[0].date);
        }
      };

      self.toggleDatePicker = function () {
        self.isDatePickerShowing = !self.isDatePickerShowing;
      };

      self.updateReceiptDetails = function() {

        self.isUpdating = true;

        var receiptDetails = {
          id: self.receipt.id,
          companyId: UserModel.currentUser().companyId,
          description: self.description,
          amount: self.amount,
          date: self.date
        };

        ReceiptRepository.update(receiptDetails)
          .then(function () {
            toastr.success(self.updateSuccess);
            updateLocalReceipt(receiptDetails);
            self.closeEdit();
          }).catch(function () {
            toastr.error(self.updateFailure);
        }).finally(function () {
          self.isUpdating = false;
        });
      };

      function updateLocalReceipt(receiptDetails) {
        self.receipt.details = [_.cloneDeep(receiptDetails)];
      }

    }
  });



//////////////////
// WEBPACK FOOTER
// ./src/main/resources/static/scripts/components/receiptFooterDetailsEdit.js
// module id = 475
// module chunks = 0